import React from 'react';
import MenuMain from '../../MenuMain';
import { FormBoletim } from '../../components/FormBoletim';
import { AppFooter } from '../../AppFooter';


export default function CadastrarBoletimPage() {

  const defaultValues = {
      "dataVisita": "",
      "dataEmissao": "",
      "produtorId": 0,
      "produtorNome": "",
      "propriedadeId": 0,
      "propriedadeNome": "",
      "tecnicoId": 0,
      "tecnicoNome": ""
  }

  return (
    <div>
      <MenuMain>
         <FormBoletim
          defaultValues={defaultValues}
          
        />
      </MenuMain>
      <AppFooter />
    </div>
  );
}

